<script lang="ts" setup>
import { useAuth } from "#imports";
import type { UserTier } from "~/stores/user";
const authStore = useAuth();

const props = defineProps<{
  tier: UserTier;
}>();
</script>
<template>
  <div class="check-email-wrapper">
    <video autoplay playsinline loop muted class="message-animation">
      <source src="/media/videos/little-star-dude.webm" type="video/webm" />
    </video>
    <h3>
      {{
        props.tier === "premium"
          ? "Thank you for becoming a Premium Member"
          : "Thank you for becoming a Supporter"
      }}
    </h3>

    <div v-if="!authStore.authUser">
      <h4>We've Sent an invite to you via Email</h4>
      <p>
        Please check your email for the invitation and click the link to
        activate your account. If you don't see it, please check your spam
        folder.
      </p>
    </div>
    <div v-else>
      <br />
      <p>
        You can now access {{ props.tier }} only content. If you have any
        problems accessing your content please reach out to us at
        <a href="mailto:help@mappr.com">help@mappr.com</a>
      </p>
    </div>
    <small class="copy"
      >Animation by
      <a href="https://lottiefiles.com/nswierz">Natalia Świerz</a></small
    >
  </div>
</template>

<style scoped>
.check-email-wrapper {
  max-width: 30rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 6rem 2rem 1rem;
}
h3 {
  margin: 2rem 0 0.5rem;
}
h4 {
  color: var(--color-rose-400);
  margin: 1.5rem 0 2rem;
}
p {
  color: var(--color-slate-500);
}
.message-animation {
  width: 100px;
  position: absolute;
  top: -1rem;
}
.copy {
  display: none;
}
</style>
